import { Directive, ElementRef, AfterViewInit, Renderer2 } from '@angular/core';
// This is temporary fix for p-selectButton in date-range component - broken area reference accessibility issue
// can be ommited once PrimeNg library fixes its internal issue in future updates

@Directive({
  selector: '[appFixSelectButtonAria]',
  standalone: true
})
export class FixSelectButtonAriaDirective implements AfterViewInit {

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    const radios = this.el.nativeElement.querySelectorAll('[role="radio"]');

    radios.forEach((radio: HTMLElement) => {
      const labelledby = radio.getAttribute('aria-labelledby');

      if (labelledby && !document.getElementById(labelledby)) {
        // Remove invalid aria-labelledby to avoid broken ARIA reference errors
        this.renderer.removeAttribute(radio, 'aria-labelledby');
      }
    });
  }
}